<template>
  <div class="popup-backdrop" v-if="isVisible"
       @click.stop="onClose" v-touch.stop="onClose">
    <div class="popup" :class="popupClasses" :style="myBlockProps.getStyles(visible)">
      <div v-if="image" class="popup-image">
        <img :class="imageClasses" :src="image">
      </div>
      <div :style="popupTitleStyle" v-if="hasRecommendationText">{{ recommendationTranslate }}</div>
      <div v-for="product in recommendedProducts" :key="product.productGuid"
           class="product-recommendation">
        <div :style="commercialNameStyle">
          <b>{{ translate(product.commercialName) }}</b> <i>{{ productPrice(product) }}</i>
        </div>
        <div :style="commercialDescriptionStyle">
          {{ translate(product.commercialDescription) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { ProductProps } from '../models/styleModels/ProductProps';
import { MultiLanguageText, TextProps } from '../models';
import Block from './Block.vue';

export default {
  name: 'initial-recommendation-block',
  extends: Block,
  props: {
    recommendedProducts: { type: Array, default: () => [] },
    recommendationText: { type: Object, required: true },
    image: { type: String },
    productProps: { type: Object, required: true, default: () => ({}) },
    recommendationTextProps: { type: Object, required: true, default: () => ({}) },
  },
  data() {
    return {
      isVisible: true,
    };
  },
  computed: {
    ...mapGetters(['getProductPrice', 'selectedLanguage']),
    myTitle() {
      return new MultiLanguageText(this.title);
    },
    myRecommendation() {
      return new MultiLanguageText(this.recommendationText);
    },
    myProductProps() {
      return new ProductProps(this.productProps);
    },
    myRecommendationTextProps() {
      return new TextProps(this.recommendationTextProps);
    },
    titleTranslate() {
      return this.myTitle.getText(this.selectedLanguage);
    },
    recommendationTranslate() {
      return this.myRecommendation.getText(this.selectedLanguage);
    },
    hasRecommendationText() {
      return this.recommendationTranslate.length > 0;
    },
    popupClasses() {
      return this.hasRecommendationText ? 'popup-padding' : 'popup-no-padding';
    },
    popupTitleStyle() {
      return this.myRecommendationTextProps.getStyles();
    },
    commercialNameStyle() {
      return this.myProductProps.popupCommercialNameTextProps.getStyles();
    },
    commercialDescriptionStyle() {
      return this.myProductProps.popupLongCommercialDescriptionTextProps.getStyles();
    },
    imageClasses() {
      if (this.hasRecommendationText && this.recommendedProducts.length > 0) {
        return 'img-small';
      }
      if (this.hasRecommendationText || this.recommendedProducts.length > 0) {
        return 'img-medium';
      }
      return 'img-large';
    }
  },
  methods: {
    onClose() {
      this.isVisible = false;
    },
    beforeEnter() {
      return 'ok';
    },
    translate(item) {
      return (item !== undefined) ? item[this.selectedLanguage] : '';
    },
    productPrice(recommendation) {
      return this.getProductPrice(recommendation.productGuid) || '';
    },
  },
};
</script>

<style scoped lang="scss">
.popup-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup {
  background-color: #ffffff;
  box-shadow: rgba(0, 0, 0, 0.29) 5px 5px 25px 0;
  border-radius: 25px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: fit-content;
  max-width: 85%;
  height: fit-content;
  max-height: 525px;
}

.popup-padding {
  padding: 20px 20px 30px 20px;
}

.popup-no-padding {
  padding-top: 4px;
}

.product-recommendation {
  padding: 10px;
}

.popup-title {
  text-align: center;
  color: black;
  margin-top: 5px;
  font-size: 1.5em;
  font-weight: bold;
}

.popup-image {
  text-align: center;

  img {
    object-fit: contain; /* This is need for safari to respect aspect ratio*/
    width: fit-content;
    max-width: 90%;
    height: fit-content;
    max-height: 325px;
    border-radius: 10px;
  }
}

.img-small {
  height: 55vh;
}

.img-medium {
  height: 60vh;
}

.img-large {
  height: 65vh;
}

</style>
